import { ApiResponse, err, getAxios, postAxios, processError, res } from "./axios";

export const getUserCartItems = async ():Promise<ApiResponse> => {
  try {
    const result = await getAxios(`/api/v1/cart/`, false)
    const response = result?.data || null
    return res(response)

  } catch (e) {
    const {status, message} = processError(e, "Error retrieving user cart.")
    return err(message, status)
  }
}

interface AddItemProps {
  lat: number | null
  lon: number | null
  model: string
  start_date: string | Date | null
  end_date: string | Date | null
  project_id: string | number | null
  params?: {
    [key: string]: any
  } | null
  provider: string
  geography: string
  version: string | null
}

export const addCartItem = async ({
  ...props
}: AddItemProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/cart/add`, {
      ...props
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error adding item to cart.")
    return err(message, status)
  }
}

interface RemoveItemProps {
  id: number | string
}

export const removeItem = async ({
  id
}: RemoveItemProps):Promise<ApiResponse> => {
  try {
    const result = await postAxios(`/api/v1/cart/remove`, {
      id,
    }, false)
    const response = result?.data || null
    return res(response)
  } catch (e) {
    const {status, message} = processError(e, "Error remove item from cart.")
    return err(message, status)
  }
}